import type React from "react";
import {
  TableRow,
  TableCell,
  Typography,
  Box,
  Chip,
  IconButton,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import { alpha } from "@mui/material/styles";
import { IService } from "../../../../types/package";
import { useThemeColors } from "../hooks/UseThemeColors";

interface ServiceTableRowProps {
  service: IService;
  onEdit: (service: IService) => void;
}

const ServiceTableRow: React.FC<ServiceTableRowProps> = ({
  service,
  onEdit,
}) => {
  const { primaryColor, darkText, secondaryText } = useThemeColors();

  return (
    <TableRow>
      <TableCell>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          {service.name}
        </Typography>
        {service.description && (
          <Box
            sx={{ color: darkText }}
            dangerouslySetInnerHTML={{
              __html: service.description,
            }}
          />
        )}
      </TableCell>
      <TableCell>${service.price}</TableCell>
      <TableCell>{service.service_category}</TableCell>
      <TableCell>{service.variation}</TableCell>
      <TableCell>
        <Chip
          label={service.status}
          size="small"
          sx={{
            backgroundColor:
              service.status === "Active"
                ? alpha(primaryColor, 0.1)
                : alpha(secondaryText, 0.1),
            color: service.status === "Active" ? primaryColor : secondaryText,
          }}
        />
      </TableCell>
      <TableCell>
        <IconButton size="small" onClick={() => onEdit(service)}>
          <Edit fontSize="small" sx={{ color: primaryColor }} />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default ServiceTableRow;
